export const customStyles_tabla = {
    table: {
		style: {
			width:"700px",
            margin:"auto",
            "table-layout":"fixed",
            border:"1px solid black"
		},
	},
    headRow: {
        style: {
            backgroundColor: "#243165",
            color: "white",
            fontSize: '1.2em',
            'text-align':'center',
            margin:'1px'
            
        },
        denseStyle: {
            minHeight: '32px',
        },
    },
    rows: {
        style: {
            minHeight: '50px',
            fontSize: '1em',
            paddingLeft: '0px',
            paddingRight: '0px',
            'text-align':'center'
        },
    },
    pagination: {
        style: {
            'justify-content': 'flex-end',
            color: "#243165",
            fontSize: '1em',
            minHeight: '56px',
            borderTopStyle: 'solid',
            borderTopWidth: '1px',
        },
    }
}



export const mensajesError = {
    formularios:{
        mensajeCamposIncompletos : "Ocurrió un error: por favor complete la información de todos los campos obligatorios (*)."
    }
}

export function mensajeCamposIncompletos (){
    window.scrollTo({
        top: 0,
        behavior: "auto"
    });
    return mensajesError.formularios.mensajeCamposIncompletos;

}